import React, { useEffect, useState } from 'react';
import { Popup } from '../../../../../ui/Modal/Popup';
import { LoaderContainer, LoaderEnum, MiniLoader } from '../../../../../ui/Loader/MiniLoader';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { AgreementCheckboxContainer, AgreementTextRow, PersonalDataAgreementContainer } from '../styles';
import { IconContainer } from '../../../../../components/ui/Content';
import { Body1, Body1PointerLink } from '../../../../../components/Font';
import { CheckBoxOff, CheckBoxOn } from '../../../../../icon/Icon';
import { AgreementType } from '../functions/checkRegFormFunctions';

interface IProps {
	personalDataAgreement: boolean;
	setPersonalDataAgreement: (value: boolean) => void;
	electronicInteractionAgreement: boolean;
	setElectronicInteractionAgreement: (value: boolean) => void;
	confidentialityAgreement: boolean;
	setConfidentialityAgreement: (value: boolean) => void;
	agreementModalType: AgreementType | null;
	setAgreementModalType: (value: AgreementType | null) => void;
}

export const PersonalDataAgreement: React.FC<IProps> = ({
	personalDataAgreement,
	setPersonalDataAgreement,
	electronicInteractionAgreement,
	setElectronicInteractionAgreement,
	confidentialityAgreement,
	setConfidentialityAgreement,
	agreementModalType,
	setAgreementModalType,
}) => {
	const [iframeLoaded, setIframeLoaded] = useState(false);
	const { t } = useTranslation();
	const Theme = useTheme();

	useEffect(() => {
		if (agreementModalType === null) {
			setIframeLoaded(false);
		}
	}, [agreementModalType]);

	const iframeLoadedHandler = () => setIframeLoaded(true);

  const AgreementCheckbox = ({
		checked,
		onChange,
		text,
		linkText,
		modalType
	}: {
		checked: boolean;
		onChange: (value: boolean) => void;
		text: string;
		linkText: string;
		modalType: AgreementType;
	}) => (
		<AgreementCheckboxContainer>
			<IconContainer onClick={() => onChange(!checked)}>
				{checked ? <CheckBoxOn /> : <CheckBoxOff />}
			</IconContainer>
			<AgreementTextRow>
				<Body1>{text}</Body1>
				<Body1PointerLink
					onClick={() => {
						setAgreementModalType(modalType);
					}}
				>
					{linkText}
				</Body1PointerLink>
			</AgreementTextRow>
		</AgreementCheckboxContainer>
	);

	return (
		<>
			<Popup
				opened={agreementModalType !== null}
				style={{ padding: '0' }}
				styleHeader={{ padding: '9px 8px 0' }}
				onClose={() => {
					setAgreementModalType(null);
				}}
			>
				<>
					{agreementModalType === AgreementType.personalDataProcessing && (
						<iframe onLoad={iframeLoadedHandler} src={t('registrationPage.personalDataProcessingLink')} />
					)}
          {agreementModalType === AgreementType.electronicInteractionAgreement && (
						<iframe onLoad={iframeLoadedHandler} src={t('registrationPage.electronicInteractionAgreement')} />
					)}
					{agreementModalType === AgreementType.confidentialPolicy && (
						<iframe onLoad={iframeLoadedHandler} src={t('registrationPage.personalDataPolicyLink')} />
					)}
					{!iframeLoaded && (
						<LoaderContainer>
							<MiniLoader color={Theme.color.indicator} size={LoaderEnum.medium} />
						</LoaderContainer>
					)}
				</>
			</Popup>

       <PersonalDataAgreementContainer>
        <AgreementCheckbox
          checked={personalDataAgreement}
          onChange={setPersonalDataAgreement}
          text={t('registrationPage.checkBoxCaption1')}
          linkText={t('registrationPage.checkBoxCaptionLink')}
          modalType={AgreementType.personalDataProcessing}
        />

        <AgreementCheckbox
          checked={electronicInteractionAgreement}
          onChange={setElectronicInteractionAgreement}
          text={t('registrationPage.checkBoxCaption2')}
          linkText={t('registrationPage.checkBoxCaptionLink2')}
          modalType={AgreementType.electronicInteractionAgreement}
        />

        <AgreementCheckbox
          checked={confidentialityAgreement}
          onChange={setConfidentialityAgreement}
          text={t('registrationPage.checkBoxCaption3')}
          linkText={t('registrationPage.checkBoxCaptionLink3')}
          modalType={AgreementType.confidentialPolicy}
        />
      </PersonalDataAgreementContainer>
		</>
	);
};
